import React from "react";

const Divider = ({ height, position, rotation, color, isOpening, isDouble}) => {
  const scaleMultiplier = isDouble ? 1 : (isOpening ? 2 : 1);
  const width = isDouble ? 0.05 : 0.02;
  const widthZ = isDouble ? 0.05 : 0.03;
  const dividerHeight = isDouble ? height + 0.106 : height;

  return (
    <mesh
      position={position}
      rotation={rotation}
      scale={[scaleMultiplier, 1, scaleMultiplier]} // genişlik ve derinliği büyüt
    >
      <boxGeometry args={[width, dividerHeight, widthZ]} />
      <meshStandardMaterial color={color} />
    </mesh>
  );
};

export default Divider;
